import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { computerOpponents, BotData, getBotSkillLevel } from "@/lib/bot-constants";
import { AvatarDisplay } from "@/components/AvatarDisplay";

interface ChallengeAISquadProps {
  onShowBotChallenge: (bot: BotData) => void;
}

export function ChallengeAISquad({ onShowBotChallenge }: ChallengeAISquadProps) {
  // Debug logging for bot data
  console.log('🤖 ChallengeAISquad rendering with bots:', computerOpponents.map(bot => ({ 
    name: bot.name, 
    elo: bot.elo, 
    skillLevel: getBotSkillLevel(bot.elo) 
  })));

  return (
    <div className="space-y-6" data-section="ai-squad">
      <div className="text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-2 bg-gradient-to-r from-teen-green to-teen-purple bg-clip-text text-transparent">
          Challenge the AI Squad! 🤖
        </h2>
        <p className="text-lg text-muted-foreground">
          Pick your opponent and show off your skills!
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4 max-w-7xl mx-auto">
        {computerOpponents.map((bot) => (
          <Card 
            key={bot.name}
            className="group cursor-pointer transition-all duration-300 hover:shadow-teen-glow hover:scale-105 border-border/50 bg-card/50 hover:bg-card/80"
            onClick={() => onShowBotChallenge(bot)}
          >
            <CardContent className="p-6 text-center">
              <div className="flex flex-col items-center gap-3">
                <AvatarDisplay
                  username={bot.name}
                  avatarConfig={bot.avatarConfig}
                  size="xl"
                  showAnimation={true}
                  animationType="idle"
                  className="group-hover:scale-110 transition-transform duration-300"
                />
                <div>
                  <h3 className="font-bold text-lg mb-1">{bot.name}</h3>
                  <p className="text-sm text-muted-foreground mb-2">{bot.description}</p>
                  <Badge 
                    variant={`teen-${bot.color.includes('green') ? 'green' : 
                             bot.color.includes('cyan') ? 'cyan' :
                             bot.color.includes('blue') ? 'blue' :
                             bot.color.includes('orange') ? 'orange' :
                             bot.color.includes('purple') ? 'purple' :
                             bot.color.includes('pink') ? 'pink' :
                             bot.color.includes('gold') ? 'gold' : 'red'}`}
                  >
                    Level: {getBotSkillLevel(bot.elo)}
                  </Badge>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}